module.exports = __webpack_public_path__ + "static/media/03.73c08077.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/volumetric/shoes/03.png
// module id = 640
// module chunks = 0